"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var cssAnchorName = 'content-quote';
exports.cssAnchorName = cssAnchorName;

var ContentQuote = function ContentQuote(_ref) {
  var content = _ref.content,
      username = _ref.username,
      parentEl = _ref.parentEl;
  parentEl.className = 'content-quote-container';
  return username && (0, _preact.h)("div", {
    className: "content-quote-username"
  }, (0, _preact.h)("span", null, username), "\xA0", (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "wrote"
  }), ":");
};

var _default = ContentQuote;
exports.default = _default;